import React, { useState, useContext, useEffect } from 'react';

import RetailerContext from '../../context';

import CanadaBeefLogo from '../../shared/svg/CanadaBeefLogo.svg';

import { Box } from '@mui/material';

import './Logo.scss';
import { string } from 'prop-types';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { getTranslation } from '../../utils/translate';
import { useSelector } from 'react-redux';

const Logo = ({ logoOverrideId, style = {} }) => {
  const { retailer } = useContext(RetailerContext);
  const language = useSelector(state => state.language);
  const translatedRetailer = getTranslation(retailer, { key: 'languages_code', code: language.code });

  const [logo, setLogo] = useState(CanadaBeefLogo);

  useEffect(() => {
    // set retailer logo if it exists
    if (translatedRetailer?.logo || retailer?.logo?.id) {
      setLogo(`${process.env.REACT_APP_API_URL}/assets/${translatedRetailer?.logo || retailer?.logo?.id}?key=brand-logo`)
    }

    if (logoOverrideId) {
      setLogo(`${process.env.REACT_APP_API_URL}/assets/${logoOverrideId}?key=brand-logo`)
    }
  }, [retailer, logoOverrideId, translatedRetailer])

  return (
    <Link
      to="/"
    >
      <Box
        className="logo_info"
        sx={{}}
      >
        <img
          src={logo}
          alt="img"
          className="logo_img"
          style={{
            zIndex: 1,
            position: "relative",
            ...style
          }}
        />
      </Box>
    </Link>
  );
};

Logo.propTypes = {
  logoOverrideId: string,
};

export default Logo;
